import React from 'react';
import {Col, Row} from "antd";

import './container-wraps.scss';


const ContainerWrap = ({
        children,
        className = "",
        spanList={
            xs: 24, md: 24, lg: 24, xl: 20, xxl: 17, span: 24
        }
}) => {

    return (
        <Row className={`main-wrap ${className}`} type="flex" justify="center" gutter={0}>
            <Col { ...spanList }>
                {children}
            </Col>
        </Row>
    );
};

export default ContainerWrap;